var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/size-guide/measurement-guide.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row o-column o-extra-small--12 o-accordion js-accordion\" role=\"tablist\">\n\n    <div class=\"o-accordion__tabset js-accordion-tabset is-collapsed s-last-tab\" data-accordion-tab-name=\"measurementGuides\">\n\n        <div id=\"measurement-guides__tab\" class=\"o-accordion__tab js-accordion-tab\" aria-selected=\"true\" aria-controls=\"condition__panel\" aria-expanded=\"false\" role=\"tab\" data-accordion-title=\"measurementGuides\">\n\n            <h3 class=\"o-accordion__label c-size-guide__accordion-label\">\n                ";
output += runtime.suppressValue((lineno = 7, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["size-guide_measurement-guide-title"])), env.opts.autoescape);
output += "\n            </h3>\n\n            <span class=\"o-accordion__control\" title=\"collapse\"></span>\n        </div>\n\n        <div id=\"measurement-guides___panel\" class=\"s-cms o-accordion__panel js-accordion-panel\" aria-labelledby=\"measurement-guides__tab\" aria-hidden=\"false\" role=\"tabpanel\">\n\n            ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, runtime.contextOrFrameLookup(context, frame, "measurementGuide")), env.opts.autoescape);
output += "\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/size-guide/measurement-guide.j2"] , dependencies)